/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { webHookNtechRequestSchema } from "./webHookNtechRequestSchema.ts";

export const orgNtechWebhookNotifyStaffAppearenceCreateStatus200Schema = z.any();

export const orgNtechWebhookNotifyStaffAppearenceCreateResponseSchema = orgNtechWebhookNotifyStaffAppearenceCreateStatus200Schema;

export const orgNtechWebhookNotifyStaffAppearenceCreateDataSchemaJson = z.array(webHookNtechRequestSchema);

export const orgNtechWebhookNotifyStaffAppearenceCreateDataSchemaXml = z.array(webHookNtechRequestSchema);

export const orgNtechWebhookNotifyStaffAppearenceCreateDataSchema = z.union([
	orgNtechWebhookNotifyStaffAppearenceCreateDataSchemaJson,
	orgNtechWebhookNotifyStaffAppearenceCreateDataSchemaXml,
]);
